module.exports = __webpack_public_path__ + "static/media/Sketch3.e3384faa.jpeg";